export default __webpack_public_path__ + "static/sfha-associate–logo-0bb3d283e9d85e7b60ad3287ff7c3c80.png";